import { apiProxyRequest } from "Api/apiProxyRequest";

import type { OrganizationVoucher } from "./types";

export const addOrganizationVoucherRequest = (
  organizationId: string,
  code: string
) => {
  return apiProxyRequest<OrganizationVoucher>(
    `/organizations/${organizationId}/vouchers/apply`,
    "POST",
    {
      code
    }
  );
};
